import { parseISO } from 'date-fns';

import player1Url from './assets/player1.svg';
import player2Url from './assets/player2.svg';

export const NEON_CHRISTMAS_START_DATE = parseISO('2024-12-01T11:00:00+01:00');

export type DailyEvent = {
  day: number;
  area: number;
  pictureUrl?: string;
};

export const NEON_CHRISTMAS_EVENTS: DailyEvent[] = [
  { day: 6, area: 1 },
  { day: 15, area: 2, pictureUrl: player1Url },
  { day: 20, area: 1 },
  { day: 2, area: 1 },
  { day: 22, area: 1 },
  { day: 23, area: 1 },
  { day: 12, area: 1 },
  { day: 3, area: 1 },
  { day: 11, area: 1 },
  { day: 14, area: 1 },
  { day: 8, area: 2, pictureUrl: player2Url },
  { day: 10, area: 1 },
  { day: 4, area: 2, pictureUrl: player1Url },
  { day: 21, area: 1 },
  { day: 13, area: 1 },
  { day: 19, area: 2, pictureUrl: player2Url },
  { day: 5, area: 1 },
  { day: 1, area: 2, pictureUrl: player1Url },
  { day: 24, area: 2, pictureUrl: player2Url },
  { day: 17, area: 1 },
  { day: 7, area: 1 },
  { day: 16, area: 1 },
  { day: 18, area: 1 },
  { day: 9, area: 1 },
] as const;

export const getAdventCalendarDimensions = (width: number, height: number) => {
  if (!width || !height) {
    return [3, 10];
  }
  const totalArea = NEON_CHRISTMAS_EVENTS.reduce<number>(
    (acc, cur) => acc + cur.area,
    0
  );

  const cols = Math.round(Math.sqrt((width / height) * totalArea));
  const rows = Math.ceil(totalArea / cols);
  return [rows, cols];
};
